module.exports = {
	delegate(el, evt, sel, handler) {
		el.addEventListener(evt, function(event) {
			var t = event.target;
			while (t && t !== this) {
				if (t.matchesSelector(sel)) {
					handler.call(t, event);
				}
				t = t.parentNode;
			}
		});
	},

	extend(out) {
		/*eslint-disable*/
		const extended = out || {};

		for (var i = 1; i < arguments.length; i++) {

			if (!arguments[i])
				continue;

			for (var key in arguments[i]) {
				if (arguments[i].hasOwnProperty(key))
					out[key] = arguments[i][key];
			}
		}

		return extended;
		/*eslint-enable*/
	},

	getCoords(elem) {
		var box = elem.getBoundingClientRect();

		var body = document.body;
		var docEl = document.documentElement;

		var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
		var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

		var clientTop = docEl.clientTop || body.clientTop || 0;
		var clientLeft = docEl.clientLeft || body.clientLeft || 0;

		var top = (box.top + scrollTop) - clientTop;
		var left = (box.left + scrollLeft) - clientLeft;

		return { top: Math.round(top), left: Math.round(left) };
	},

	getMaxScroll($elem) {
		const values = {
			innerX: Math.max(
				$elem.scrollWidth,
				$elem.offsetWidth
			),
			innerY: Math.max(
				$elem.scrollHeight,
				$elem.offsetHeight
			)
		};

		values.maxX = values.innerX - $elem.offsetWidth;
		values.maxY = values.innerY - $elem.offsetHeight;

		return values;
	},

	getRandomInt(min, max) {
		// Get a random number in a range
		return Math.floor(Math.random() * (max - (min + 1))) + min;
	},

	htmlToElement(html) {
		const $template = document.createElement('div');

		$template.innerHTML = html;

		return $template.firstChild;
	},

	idify(id) {
		return id.replace(/\W/g, '-');
	},

	rangeToRange(oldVal, oldMax, oldMin, newMax, newMin) {
		// Takes one range and converts it to another! Easy as pie! We love pie.
		return (((oldVal - oldMin) * (newMax - newMin)) / (oldMax - oldMin)) + newMin;
	},

	get isIE11() {
		const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

		return isIE11;
	},

	get isEdge() {
		const isEdge = window.navigator.userAgent.indexOf('Edge') > -1;

		return isEdge;
	},
};



// WEBPACK FOOTER //
// ./src/js/modules/utils.js